// extracted by mini-css-extract-plugin
module.exports = {"citationInputText":"input-text_citationInputText__4yBSB","input":"input-text_input__PW5L4","inputWarning":"input-text_inputWarning__hzLfr"};